import { useEffect, useState } from "react";
import Select from "react-select";
import { addCrewUser, addNewCrew, getUserDetails } from "../API";
import { toast } from "react-toastify";

const AddNewCrewModal = ({ addNewCrewUser }) => {
  // const [isAnyEmpty, setIsAnyEmpty] = useState(true);
  const [crewRoles, setCrewRoles] = useState({
    foreman: {
      user_id: "",
      crew_role_id: 1,
    },
    generalForeman: {
      user_id: "",
      crew_role_id: 2,
    },
    opsManager: {
      user_id: "",
      crew_role_id: 3,
    },
  });

  const [userOptions, setUserOptions] = useState([]);

  // Fetch the list of all users and set the initial options
  const fetchAllUserList = async () => {
    const allUsers = await getUserDetails();
    const userOptions = allUsers?.data?.map((user) => {
      return { label: user?.name, value: user?.id };
    });
    setUserOptions(userOptions);
  };

  useEffect(() => {
    fetchAllUserList();
  }, []);

  // useEffect(() => {
  //   const anyEmpty = Object.values(crewRoles).some((role) => !role.user_id);
  //   setIsAnyEmpty(anyEmpty);
  // }, [crewRoles]);

  // Handle dropdown changes and update the state accordingly
  const handleOnDropDownChange = (item, role) => {
    setCrewRoles((prevState) => ({
      ...prevState,
      [role]: { ...prevState[role], user_id: item?.value },
    }));
  };

 
  const filterOptions = (role) => {
    const selectedIds = Object.values(crewRoles)
      .map((role) => role.user_id)
      .filter((id) => id);

    // Include the current role's user_id in the options to allow the user to keep the selection
    return userOptions.filter(
      (option) =>
        !selectedIds.includes(option.value) ||
        option.value === crewRoles[role].user_id
    );
  };

  const onClickCross = () => {
    // setIsAnyEmpty(true);
    setCrewRoles({
      foreman: {
        user_id: "",
        crew_role_id: 1,
      },
      generalForeman: {
        user_id: "",
        crew_role_id: 2,
      },
      opsManager: {
        user_id: "",
        crew_role_id: 3,
      },
    });
  };

  const onClickAddCrew = async () => {
    if (
      crewRoles?.foreman?.user_id ||
      crewRoles?.generalForeman?.user_id ||
      crewRoles?.opsManager?.user_id
    ) {
      const payload = { name: "" };

      try {
        const res = await addNewCrew(payload);
        if (res?.status === 200) {
          const addCrewPromises = Object.keys(crewRoles).map((item) => {
            if (crewRoles[item]?.user_id !== "") {
              const user_id = crewRoles[item]?.user_id;
              const crew_role_id = crewRoles[item]?.crew_role_id;
              const payload = {
                crew_id: res?.data?.id,
                user_id,
                crew_role_id,
              };
              return addCrewUser(payload);
            }
          });

          await Promise.all(addCrewPromises);
          addNewCrewUser();
          toast.success("Crew created successfully");
        }
      } catch (err) {
        console.log("Error occurred while adding new crew", err);
      }
    } else {
      toast.warning("Please enter the required fields");
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn primary-btn-outlined px-3"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
      >
        + Add Crew
      </button>
      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title font-weight-bold"
                id="exampleModalLabel"
              >
                Add A New Crew
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => onClickCross()}
              ></button>
            </div>
            <div className="modal-body">
              <form>
                {/* <div className="mb-3">
                  <label htmlFor="recipient-name" className="col-form-label">
                    Name*
                  </label>
                  <input
                    value={addCrewDetails?.name}
                    onChange={(e) => onHandleChange(e)}
                    name="name"
                    type="text"
                    className="form-control"
                  />
                </div> */}
                <label className="col-xl-3 col-form-label">Foreman</label>{" "}
                <div className="col-xl-12">
                  <Select
                    name="foreman"
                    placeholder="Select"
                    value={
                      crewRoles.foreman.user_id
                        ? userOptions.find(
                            (option) =>
                              option.value === crewRoles.foreman.user_id
                          )
                        : null
                    }
                    onChange={(data) => handleOnDropDownChange(data, "foreman")}
                    aria-label="Default select example"
                    options={filterOptions("foreman")}
                  />
                </div>
                <label className="col-form-label">General Foreman</label>
                <div className="col-xl-12">
                  <Select
                    name="generalForeman"
                    placeholder="Select"
                    value={
                      crewRoles.generalForeman.user_id
                        ? userOptions.find(
                            (option) =>
                              option.value === crewRoles.generalForeman.user_id
                          )
                        : null
                    }
                    onChange={(data) =>
                      handleOnDropDownChange(data, "generalForeman")
                    }
                    aria-label="Default select example"
                    options={filterOptions("generalForeman")}
                  />
                </div>
                <label className="col-form-label">Ops Manager</label>
                <div className="col-xl-12">
                  <Select
                    name="opsManager"
                    placeholder="Select"
                    value={
                      crewRoles.opsManager.user_id
                        ? userOptions.find(
                            (option) =>
                              option.value === crewRoles.opsManager.user_id
                          )
                        : null
                    }
                    onChange={(data) =>
                      handleOnDropDownChange(data, "opsManager")
                    }
                    aria-label="Default select example"
                    options={filterOptions("opsManager")}
                  />
                </div>
                {/* <div className="col-md-12 col-lg-12">
                  <div className="mb-3">
                    <label htmlFor="recipient-name" className="col-form-label">
                      Project*
                    </label>
                    <Select
                      placeholder="Select Project"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      name="colors"
                      options={projectOptions}
                      onChange={(item) => onHandleChange(item)}
                    />
                  </div>
                </div> */}
              </form>
            </div>
            <div className="modal-footer">
              <button
                // disabled={isAnyEmpty}
                onClick={() => onClickAddCrew()}
                type="button"
                className="primary-btn"
                data-bs-dismiss="modal"
              >
                + Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewCrewModal;
